/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LoadingButton from '../loading_button';

const ProgressButton = ({
  variant = 'button',
  loading,
  succeeded,
  isDisabled = false,
  defaultText,
  loadingText,
  succeededText,
  failedText = defaultText,
  onClick,
  ...props
}) => {
  if (loading) {
    return (
      <LoadingButton
        loading
        disabled
        className={classNames({
          'link-grey pe-none text-decoration-none':
            variant === 'link' || variant === 'danger-link',
          'btn btn-primary': variant === 'button',
        })}
        {...props}
      >
        {loadingText}
      </LoadingButton>
    );
  }
  if (succeeded === true) {
    return (
      <LoadingButton
        succeeded
        className={classNames({
          'link-success text-decoration-underline':
            variant === 'link' || variant === 'danger-link',
          'btn btn-success': variant === 'button',
        })}
        {...props}
      >
        {succeededText}
      </LoadingButton>
    );
  }
  if (succeeded === false) {
    return (
      <LoadingButton
        succeeded={false}
        className={classNames({
          'link-primary text-decoration-underline': variant === 'link',
          'link-danger text-decoration-underline': variant === 'danger-link',
          'btn btn-primary': variant === 'button',
        })}
        {...props}
        onClick={onClick}
      >
        {failedText}
      </LoadingButton>
    );
  }
  return (
    <LoadingButton
      disabled={isDisabled}
      className={classNames({
        'link-primary text-decoration-underline': variant === 'link',
        'link-danger text-decoration-underline': variant === 'danger-link',
        'btn btn-primary': variant === 'button',
      })}
      {...props}
      onClick={onClick}
    >
      {defaultText}
    </LoadingButton>
  );
};

export default ProgressButton;

ProgressButton.propTypes = {
  variant: PropTypes.string,
  loading: PropTypes.bool,
  succeeded: PropTypes.bool,
  isDisabled: PropTypes.bool,
  defaultText: PropTypes.string,
  loadingText: PropTypes.string,
  succeededText: PropTypes.string,
  failedText: PropTypes.string,
  onClick: PropTypes.func,
};
